let nodeDomain, strapiDomain, phpDomain, frontendDomain;

if (process.env.REACT_APP_ENV === "DEV") {
  nodeDomain = "https://devnodeapi.bimastreet.com";
  strapiDomain = "https://strapi.bimastreet.com";
  phpDomain = "https://devapi.bimastreet.com";
  frontendDomain = "https://dev.bimastreet.com";
} else if (process.env.REACT_APP_ENV === "STG") {
  nodeDomain = "https://stgnodeapi.bimastreet.com";
  strapiDomain = "https://strapi.bimastreet.com";
  phpDomain = "https://stgapi.bimastreet.com";
  frontendDomain = "https://stg.bimastreet.com";
} else if (process.env.REACT_APP_ENV === "PROD") {
  nodeDomain = "https://nodeapi.bimastreet.com";
  strapiDomain = "https://strapi.bimastreet.com";
  phpDomain = "https://api.bimastreet.com";
  frontendDomain = "https://bimastreet.com";
} else {
  // Default to dev environment
  nodeDomain = "https://devnodeapi.bimastreet.com";
  strapiDomain = "https://strapi.bimastreet.com";
  phpDomain = "https://devapi.bimastreet.com";
  frontendDomain = "";
}

export const NODE_DOMAIN = nodeDomain;
export const STRAPI_DOMAIN = strapiDomain;
export const PHP_DOMAIN = phpDomain;
export const FRONTEND_DOMAIN = frontendDomain;
